import { DEFAULT_NETWORK_CODE } from "@foundation/sparkle/lib/SparkleContext";

import { getWeekendCollection, Story } from "~types/types";
import isEnabled from "~utils/features";

import { getAdCodeFromStory } from "./sparkleOptions";

const AD_CODES = {
    VIDEO: {
        AD_NETWORK_ID: "5262",
        AD_TAG_MIDROLL: "business/midroll/vod",
    },
};

export default function getArticleMetadata(content: Story) {
    const adCode = getAdCodeFromStory(content);
    const adCodes = [`${DEFAULT_NETWORK_CODE}/${adCode}`];

    const videoAttachments = content.videoAttachments || {};
    const videoAttachment = videoAttachments[Object.keys(videoAttachments)[0]];

    const adConfig = {
        adCode,
        videoAdCodes: videoAttachment && {
            preroll: `/${AD_CODES.VIDEO.AD_NETWORK_ID}/business/${videoAttachment.prerollAdUnit}`,
            midroll: `/${AD_CODES.VIDEO.AD_NETWORK_ID}/${AD_CODES.VIDEO.AD_TAG_MIDROLL}`,
        },
    };

    if (videoAttachment) {
        adCodes.push(adConfig.videoAdCodes.preroll);
        adCodes.push(adConfig.videoAdCodes.midroll);
    }

    const newsletterEntitlements = content.collections?.newsletterEntitlements
        ? content.collections?.newsletterEntitlements
        : null;

    return {
        id: content.id,
        contentType: content.resourceType,
        contentTags: content.contentTags,
        brand: content.brand,
        editorialPillar: content.pillar,
        editorialPackage:
            isEnabled("enableTheWeekend") &&
            Boolean(getWeekendCollection(content))
                ? "weekend"
                : undefined,
        franchise: content.franchise,
        archived: content.archived,
        metadata: {
            ...content.metadata,
            authors: content.authors,
            collections: {
                newsletterEntitlements,
            },
        },
        adConfig,
        adCodes,
        recordSlug: content.collections?.record?.slug,
    };
}
